<ion-grid>
    <ion-row>
        <ion-col *ngIf="!showWebcam">
            <ion-img src="assets/img/no-photo.png" class="img-container" alt="{{'take_photo' | translate}}" *ngIf="!urlImage && !currentUrlImg"></ion-img>
            <ion-img [src]="currentUrlImg" class="img-container" alt="{{'take_photo' | translate}}" *ngIf="currentUrlImg && !urlImage" style="width: 100%"></ion-img>
            <ion-img [src]="urlImage" class="img-container" alt="{{'take_photo' | translate}}" *ngIf="urlImage" style="width: 100%"></ion-img>
        </ion-col>

        <ion-col *ngIf="!showWebcam">
            <ion-button expand="block" size="small" (click)="toggleWebcam()" class="btn-footer">
                <ion-icon name="camera-outline" slot="start" style="margin-right: 4px; margin-bottom: 3px;"></ion-icon>
                {{'take_photo' | translate}}
            </ion-button>
        </ion-col>

        <ion-col *ngIf="showWebcam">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <webcam [height]="300" [width]="300" [trigger]="initObservable" (imageCapture)="takePicture($event)" 
                            [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)" (initError)="handleInitError($event)" *ngIf="showWebcam">
                        </webcam>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col style="text-align: center;">
                        <ion-button expand="block" size="small" (click)="takeSnapshot()" class="btn-footer">
                            {{ 'Capturar' | translate }}
                        </ion-button>
                    </ion-col>
                    <ion-col style="text-align: center;">
                        <ion-button expand="block" size="small" (click)="toggleWebcam()" class="btn-footer">
                            {{ 'cancelar' | translate }}
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <ng-template #imgPhoto>
                <ion-img src="assets/icons/qr-icon.svg" alt="" class="qr-icon-position"></ion-img>
            </ng-template>
        </ion-col>
    </ion-row>
  </ion-grid>